import { render, staticRenderFns } from "./SystemLogs.vue?vue&type=template&id=a6ad5ebc&scoped=true"
import script from "./SystemLogs.vue?vue&type=script&lang=ts"
export * from "./SystemLogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ad5ebc",
  null
  
)

export default component.exports